// How a game is laid out in storage. The entities themselves (`GameRecord`,
// `GameSummary`) are the model's (`@chess/api-model`); the stored shape is
// part of this API's contract: a game folder holds `game.json` (a
// GameRecord) and `game.pgn`, and every other plugin keeps its own subfolder
// beside them.
export const GAME_RECORD_FILE = 'game.json';
export const GAME_PGN_FILE = 'game.pgn';
